/* eslint-disable @typescript-eslint/no-explicit-any */
const updateBuilderPixel = (blocks: any) => {
  const builderPixel = blocks.filter((block: any) => block.id.includes('builder-pixel'))[0];
  builderPixel.properties.alt = 'Builder Tracking Pixel';
};

export default updateBuilderPixel;
